import { Box, Typography } from "@mui/material";
import profile_image from "../../assets/images/ajit_image.jpeg";
import styles from "../../screens/Dashboard/Dashboard.module.css";
import { customTextColor } from "../../utils/const";
import { useNavigate } from "react-router-dom";

const RecruiterProfile = () => {
  const navigate = useNavigate();
  return (
    <Box className={styles.recruiter_profile}>
      <div>
        <img src={profile_image} alt="" />
        <span style={{ color: customTextColor }}>
          <Typography>
            Recruiter: <b> Ashit Kumar Rout</b>
          </Typography>
          <Typography>
            Designation: <b>Sr. Recruiter</b>
          </Typography>
          <Typography sx={{ marginBottom: "0 !important" }}>
            Company: <b>Dinkins Solutions Pvt Ltd </b>
          </Typography>
        </span>
      </div>
      <span style={{ alignSelf: "flex-end" }}>
        <button style={{ backgroundColor: "#00b050 " }}>View & Edit</button>

        <button  onClick={() => navigate("/dashboard-credit")} style={{ backgroundColor: "#8faadc", marginLeft: "20px" }}>
          Add Credit
        </button>
      </span>
    </Box>
  );
};

export default RecruiterProfile;
